import { Button } from '@askable/ui/core/button';
import { isChunkLoadError } from 'src/lib/reload-on-chunk-error';

import type { ErrorComponentProps } from '@tanstack/react-router';

/**
 * Fallback for a route that threw while rendering. Replaces only the failing
 * route's slot, so the app chrome stays usable. A lazy component keeps a failed
 * import, so only a page reload retries a chunk error.
 */
export const RouteError = ({ error, reset }: ErrorComponentProps) => {
  const retry = isChunkLoadError(error) ? () => window.location.reload() : reset;

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6 text-center">
      <h2 className="text-lg font-semibold">Something went wrong</h2>
      <p className="max-w-sm text-sm text-muted-foreground">
        This page ran into an unexpected error. Try again, and if the problem persists refresh your browser.
      </p>
      <Button variant="primary" onClick={retry}>
        Try again
      </Button>
    </div>
  );
};
